import { NewCaseLetterFormFieldSchema } from "@/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { FormProvider, useForm } from "react-hook-form";

export const Route = createFileRoute("/dashboard/case/view/$id/letter/new")({
	component: RouteComponent,
});

function RouteComponent() {
	const caseId = Route.useParams({
		select: (s) => s.id,
	});
	const form = useForm<NewCaseLetterFormFieldSchema>({
		mode: "all",
		resolver: zodResolver(NewCaseLetterFormFieldSchema),
		defaultValues: {
			caseId,
		},
	});

	return (
		<FormProvider {...form}>
			<Outlet />
		</FormProvider>
	);
}
